import type { I18n } from '@/typings/i18n'

const ko: I18n = {
  global: {
    indexTitle: 'LOOK',
    tipsTitle: '팁',
    confirmButtonText: '확인',
    cancelButtonText: '취소',
    day: '일',
    people: '명',
    bindButtonText: '연동',
    help: '도움말',
    manageSubscription: '구독 관리',
    coupon: '쿠폰 확인',
    deleteMessage: '삭제하시겠습니까?',
    deleteButtonText: '삭제',
    renameButtonText: '이름 변경',
    downloadButtonText: '다운로드',
    install: '설치됨',
    phoneNumberLabel: '휴대폰 번호',
    verificationCodeLabel: '인증 코드',
    sendButtonText: '전송',
    saveButtonText: '저장',
    download: '다운로드',
    complete: '완료',
    adjustButtonText: '조정',
    eraser: '지우개',
    undo: '실행 취소',
    redo: '다시 실행',
    clear: '초기화',
    noDataMessage: '데이터 없음',
    loading: '로딩 중',
    customize: '사용자 지정',
    referenceImage: '참조 이미지',
    styleImage: '스타일 이미지',
    high: '높음',
    middle: '중간',
    low: '낮음',
    big: '큰',
    small: '작은',
    select: '선택',
    upload: '업로드',
    colon: ':',
    uploadDesc: '이 영역을 클릭하거나 파일을 끌어다 놓아 업로드하세요',
    generate: '생성',
    preview: '미리보기',
    magic: '인공지능',
    add: '추가',
    subtract: '감소',
    brush: '브러시',
    part: '부분',
    commonlyUsed: '히스토리',
    recommend: '추천',
    termsOfService: '서비스 이용약관',
    userAgreement: '사용자 동의',
    privacyStatement: '개인정보 처리방침',
    wechat: '위챗',
    xiaohongshu: '샤오홍슈',
    downloadClient: '클라이언트 다운로드',
    ok: '확인',
    and: ' 및 ',
    language: '언어',
    copy: '복사',
    copyLink: '링크 복사',
    signupTitle: '회원가입',
    signupTitleSuffix: 'LOOK AI 실시간 패션 디자인 도구',
    recentsTitle: '최근 기록 - LOOK',
    projectNameTitle: '{projectName} - LOOK',
    nextStep: '다음 단계',
    accept: '수락',
    reject: '거절',
    about: '정보',
    close: '닫기',
    skip: '건너뛰기',
    iKnow: '알겠습니다'
  },
  system: {
    updateTip: '새 버전이 다운로드되었습니다. 업데이트하려면 클릭하세요.',
    updateMessage: '애플리케이션을 종료하고 업데이트를 설치하시겠습니까?',
    drawingDownMessage: ' 기능을 사용하려면 클라이언트를 다운로드해야 합니다.',
    bonjourInstallTitle: 'Bonjour 설치되지 않음',
    bonjourInstallMessage1: '화면 미러링 수신 서비스가 설치되지 않았습니다.',
    bonjourInstallMessage2:
      ' 실시간 디자인 기능이 제대로 작동하지 않습니다. 화면 미러링 수신 서비스를 설치하고 LOOK을 다시 시작해 주세요.',
    bonjourInstallMessage3: '만약 다운로드가 여전히 작동하지 않는 경우, "사용 안함"을 클릭하세요.',
    bonjourUnavailableTitle: 'Bonjour 설치 실패',
    bonjourUnavailableMessage1: '화면 미러링 수신 서비스가 설치되지 않았습니다.',
    bonjourUnavailableMessage2: '비디오 가이드를 따라 강력하게 제거하세요.',
    bonjourUnavailableMessage3:
      '화면 미러링 수신 서비스를 다시 설치하고 LOOK을 다시 시작해 주세요.',
    bonjourUnavailableMessage4:
      '다운로드 후에도 여전히 작동하지 않는 경우, 저희 Discord를 방문해 주세요:',
    bonjourStartTitle: 'Bonjour 정상적으로 시작되지 않음',
    bonjourStartMessage1:
      '화면 미러링 수신 서비스가 정상적으로 시작되지 않았습니다. 실시간 디자인 기능이 제대로 작동하지 않습니다. 안내에 따라 시작해 주세요',
    bonjourStartMessage2: '그런 다음',
    bonjourStartMessage3: 'LOOK을 다시 시작',
    bonjourStartMessage4: '1、시스템 설정을 열고 "서비스"를 검색하세요',
    bonjourStartMessage5:
      '2、서비스에서 Bonjour를 마우스 오른쪽 버튼으로 클릭하고 "시작"을 선택하세요',
    bonjourStartMessage6: '3、LOOK을 다시 시작',
    bonjourStartMessage7:
      '다시 시작한 후에도 여전히 작동하지 않는 경우, 저희 Discord를 방문해 주세요:',
    bonjourStartText: '정상적으로 시작됨',
    bonjourUnavailable: '실시간 디자인 기능이 제대로 작동하지 않습니다.',
    bonjourDownload: 'Bonjour 다운로드',
    revoUninstaller: 'Revo Uninstaller',
    forceUninstallMessage:
      '참고: 화면 미러링 수신 서비스를 설치했지만 서비스가 설치되지 않았다는 메시지가 계속 표시되는 경우, 설치가 완전히 성공하지 않았을 수 있습니다. 강력한 제거 도구를 사용하여 Bonjour와 Bonjour SDK 애플리케이션을 모두 제거한 후 화면 미러링 수신 서비스를 다시 설치해 보세요.',
    guideButtonText: '튜토리얼',
    noImageMessage: '선택된 이미지가 없습니다',
    aboutUsTitle: '회사 소개',
    weChatPublicAccountTitle: '위챗 공식 계정',
    error400: '잘못된 요청 매개변수',
    error403: '접근 거부',
    error404: '요청한 주소를 찾을 수 없습니다',
    error408: '요청 시간 초과',
    error500: '내부 서버 오류',
    error501: '서버가 구현되지 않음',
    error502: '게이트웨이 오류',
    error503: '서비스를 사용할 수 없음',
    error504: '게이트웨이 시간 초과',
    copySuccess: '복사 성공',
    copyError: '복사 실패: ',
    browserTips: '더 나은 사용자 경험을 위해 Chrome 브라우저를 사용하여 접속하거나 ',
    serviceStopMessage:
      '프로 구독이 {date}에 자동 갱신되지 않았습니다. 기한 내에 결제하지 않으면 서비스가 중단됩니다.',
    renewalReminderMessage: '계속 사용하려면,',
    paymentLink: '결제 완료',
    updateTipsMessage: 'LOOK이 새 버전을 감지하여 업데이트를 설치하기 위해 자동으로 종료됩니다.',
    osVersionNotSupportedMessageWindows:
      'Windows 10 64비트 이하의 운영 체제 버전은 지원되지 않으며, 사용자 경험에 영향을 미칠 수 있습니다. 운영 체제를 업그레이드하거나 브라우저를 통해 접속하는 것을 권장합니다.',
    osVersionNotSupportedMessageMacOS:
      'Mac OS 13 이하의 운영 체제 버전은 지원되지 않으며, 사용자 경험에 영향을 미칠 수 있습니다. 운영 체제를 업그레이드하거나 브라우저를 통해 접속하는 것을 권장합니다.',
    updatedDownloadMessage:
      'LOOK이 새 버전을 감지하여 업데이트를 설치하기 위해 자동으로 종료됩니다.',
    receiverConnectErrorMessage: '화면 미러링 수신기 연결 오류:{message}',
    receiverStartErrorMessage: '화면 미러링 수신기 시작 오류:{message}',
    macOSVersionErrorMessage:
      '화면 미러링 수신기 시작 오류: Mac OS 버전이 너무 낮습니다. 운영 체제를 업그레이드해 주세요.',
    airplayRTPErrorMessage:
      'AirPlay 화면 미러링에서 네트워크 오류가 발생했습니다. 네트워크 연결을 확인하고 LOOK을 다시 시작해 보세요.',
    networkDisconnectedMessage:
      '네트워크 연결이 끊어져 화면 미러링이 중지되었습니다. 네트워크 연결을 확인해 주세요.',
    networkReconnectedMessage:
      '네트워크가 다시 연결되었습니다. 스트리밍을 계속하려면 LOOK을 다시 시작하고 기기를 다시 연결하세요.',
    slogan1: 'AI 실시간 패션 디자인 도구',
    slogan2: '아이디어를 즉시 현실로!',
    slogan3: '실시간 디자인, 실제 결과 확인',
    slogan4: '스케치를 즉시 렌더링으로 변환, 다양한 변형 생성',
    slogan5: '스타일 융합: 상상력의 경계를 넘어서',
    slogan6: '부분 조정: AI로 정밀한 제어',
    networkErrorMessage:
      '현재 네트워크에 연결되어 있지 않습니다. 기기의 네트워크 설정을 확인해 주세요.',
    serverErrorMessage: '서버 접속에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    languageChangeMessage: '이 언어로 전환하려면 다시 로그인해야 합니다. 전환하시겠습니까?',
    downloadAppMessage:
      '앱을 처음 다운로드하고 로그인하면<br/><span style="font-weight: 700; font-size: 24px">추가 1일 무료 체험</span>',
    downloadButtonTextMac: 'macOS용 다운로드',
    downloadButtonTextWindows: 'Windows용 다운로드',
    consentTitle: '쿠키 알림',
    consentTips:
      '더 나은 서비스와 개인화된 경험을 제공하기 위해 쿠키 및 유사한 기술을 사용하여 웹사이트 성능을 분석하고, 맞춤형 광고를 표시하며, 소셜 미디어 기능을 제공합니다. "모든 쿠키 수락"을 클릭하거나 이 사이트를 계속 사용함으로써, FedEx가 더 개인화된 경험을 제공할 수 있도록 하는 다른 분석 쿠키와 추적 쿠키에 동의하게 됩니다. 자세한 내용은 <span style="font-weight: 700; text-decoration: underline; cursor: pointer">쿠키 정책</span>을 참조하세요.',
    aboutTitle: 'LOOK 데스크톱 앱',
    currentVersion: '버전',
    newVersion: '새 버전',
    copyright: 'Copyright © 2024 LOOK AI LIMITED',
    checkUpdateButtonText: '업데이트 확인',
    updateButtonText: '{version}으로 업데이트',
    noUpdateMessage: '이미 최신 버전입니다',
    updateFailMessage: '업데이트 실패, LOOK이 다시 시작한 후 업데이트를 다시 시도합니다',
    appDownloadGuideTitle: 'LOOK 데스크톱 클라이언트 다운로드',
    appDownloadGuideSubTitle:
      '이 기능을 사용하려면 LOOK 데스크톱 클라이언트를 다운로드해야 합니다.',
    realtimeDesignGuideTitle: '실시간 디자인 가이드',
    realtimeDesignGuideSubTitle1:
      '실시간 디자인을 사용하려면 <img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> LOOK 데스크톱 클라이언트를 다운로드하고 <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> Procreate 앱과 함께 사용해야 합니다.',
    realtimeDesignGuideSubTitle2:
      '<img style="vertical-align: text-bottom" src="{image1}" width="16" height="16" /> Procreate와 <img style="vertical-align: text-bottom" src="{image2}" width="16" height="16" /> LOOK 데스크톱 클라이언트를 열고 가이드에 따라 화면 미러링 연결을 완료하세요.',
    freeCountLimitDialogTitle: '생성 한도에 도달하셨나요?',
    freeCountLimitDialogDesc:
      '앱을 처음 다운로드하고 로그인하면<br/><span style="font-weight: 600; font-size: 24px">추가 1일 무료 체험</span>',
    freeCountLimitDialogDescMobile:
      '<br/><span style="font-weight: 600">PC 또는 macOS</span>에서 앱을 처음 다운로드하고 로그인하면<br/><span style="font-weight: 600;font-size: 24px">추가 1일 무료 체험</span>',
    imageSizeTooLarge: '이미지 크기는 {size}MB를 초과할 수 없습니다'
  },
  error: {
    invitationCodeUsed: '초대 코드가 이미 사용되었습니다',
    invitationCodeInvalid: '초대 코드가 유효하지 않습니다',
    networkErrorTitle: '네트워크 오류',
    networkErrorMessage: '서버에 연결할 수 없습니다. 네트워크 연결을 확인하고 다시 시도해 주세요',
    retryButtonText: '다시 시도',
    upscaleScaleError:
      '업스케일 권한이 없습니다. 더 높은 이미지 품질을 해제하려면 플랜을 업그레이드하세요.',
    campaignSystemError: '시스템 오류, 잠시 후 다시 시도해 주세요',
    campaignUserAuthError: '사용자 식별 실패',
    campaignParamError: '매개변수 오류',
    campaignQueryError: '쿼리 오류',
    campaignNotCompleted: '활동 작업 완료되지 않음',
    campaignRewardAlreadyClaimed: '보상이 이미 주장됨',
    campaignCouponNotAvailable: '쿠폰 사용 불가능',
    campaignUseCoupon: '쿠폰 사용 실패',
    campaignAssignCoupon: '쿠폰 할당 실패',
    userGoogleAuthFail: 'Google 로그인 실패',
    userNotSupportLoginType: '지원하지 않는 로그인 유형',
    userSystemError: '시스템 오류',
    userLoginError: '로그인 실패'
  },
  account: {
    logoutMessage: '로그아웃하시겠습니까?',
    logoutButtonText: '로그아웃',
    bindPhoneTitle: '휴대폰 번호 연동',
    bindPhoneSuccessMessage: '휴대폰 번호 연동 성공',
    bindPhoneTips: '휴대폰 번호를 연동하여 무료 멤버십을 받으세요',
    bindPhoneEmptyNumberMessage: '휴대폰 번호를 입력해 주세요',
    bindPhoneErrorNumberMessage: '유효하지 않은 휴대폰 번호입니다',
    bindPhoneVerificationCodeEmptyMessage: '인증 코드를 입력해 주세요',
    getInvitationCodeErrorMessage: '초대 코드 정보를 가져오지 못했습니다',
    trialDuration: '무료 체험: ',
    headerGiftText: '쿠폰 받기',
    headerOneDayGiftText: '멤버십 {discount}% 할인',
    headerSubscribeGiftText: '지금 구독하기',
    invitePopoverTitle: '친구 초대하고 보상 받기',
    invitePopoverDescTips: '휴대폰 번호를 연동한 신규 사용자는 새로운 사용자 초대로 간주됩니다',
    invitePopoverMark: '쿠폰&nbsp;<span>$15</span>&nbsp;받기!',
    invitePopoverDesc:
      '친구를 초대할 때마다 구독/갱신에 사용할 수 있는 $15 바우처를 받게 됩니다! 친구는 15일 무료 체험을 받게 됩니다!',
    invitePopoverCodeShareTitle: '스캔하여 공유',
    invitePopoverCodeCopyTitle: '클릭하여 복사',
    invitePopoverShareCountText: '남은 초대:',
    invitePopoverSubText: '초대 코드 사용은 사용량에 따라 자동으로 할당됩니다.',
    invitePopoverGiftDaysText: '누적 바우처:',
    invitePopoverBindPhoneMaskText: '휴대폰 번호를 연동하여 초대 슬롯을 활성화하고 받으세요',
    phoneNumber: '휴대폰 번호:',
    noMemberText: 'Free',
    memberExpireAtFormat: 'YYYY/MM/DD',
    memberExpireAt: '만료일:',
    memberUpgradeMainText: '4K 이미지의 더 높은 생성 한도 잠금 해제',
    memberUpgradeMainTextFirst: '50% 할인 받기!',
    memberUpgradeSubText: '실시간 디자인의 자유를 누리세요!',
    memberUpgradeLinkTextActivate: '활성화',
    memberUpgradeLinkTextUpgrade: '업그레이드',
    memberUpgradeLinkTextGet: '받기',
    memberUpgradeLinkTextManage: '관리',
    discordLoginTitle: 'LOOK으로 시작하기',
    discordLoginButtonText: 'Discord로 로그인',
    discordLoginSubText1: '가입함으로써 LOOK AI 계정을 생성하고 LOOK AI의 ',
    discordLoginSubText2: '에 동의하게 됩니다.',
    googleLoginButtonText: 'Google로 로그인',
    invitePageTitle: '안녕하세요, 디자이너님',
    invitePageNicknamePlaceholder: '닉네임',
    invitePageInvitationCodePlaceholder: '초대 코드',
    invitePageSubmitButtonText: '시작하기',
    invitePageTips:
      '초대 코드로 <span style="font-weight: 700">추가 8일 무료 체험</span>&nbsp;받기',
    invitePageInvitationCodeInvalid: '유효하지 않은 초대 코드입니다',
    hasInvitationCodeText: '초대 코드가 있습니다',
    shareInvitationCodeText: `LOOK AI 실시간 패션 디자인 도구

💻 PC 접속: https://app.lookfashion.ai
📱 현재 모바일은 지원되지 않습니다

초대 코드: {code}`,
    limitedTitle: '잠시만요...',
    limitedTime: '{time} 후에 서비스를 계속 이용할 수 있습니다',
    limitedRealtimeDesignTime: '다음 구독 주기에 계속 이용해 주세요.',
    limitedSubject: '<span style="font-weight: 600">{name}</span>의 생성 한도에 도달했습니다.',
    upgradeTitle: '기다리기 지루하신가요?',
    upgradeSubject:
      '멤버십을 업그레이드하여 <span style="font-weight: 600">즉시 생성</span>하세요!',
    upgradeButtonText: '지금 업그레이드',
    mergeAccount: '이게 당신입니까?',
    mergeAccountDesc: '네, 계정 연결',
    mergeAccountCancel: '아니요, 로그인으로 돌아가기',
    recentLoginText: '최근의'
  },
  project: {
    recentListTitle: '최근 생성',
    collectListTitle: '즐겨찾기 목록',
    projectListTitle: '프로젝트 목록',
    emptyMessage1: '아직 생성된 프로젝트가 없습니다',
    emptyMessage2: '아래를 클릭하여 프로젝트를 생성하세요',
    emptyMessage3: '생성 시작하기',
    emptyMessage4: '아직 저장된 이미지가 없습니다. 생성하고 ',
    emptyMessage5: '저장하여 이미지를 추가하세요',
    emptyMessage6: '먼저 새 프로젝트를 만든 다음 생성하고 ',
    emptyMessage7: 'LOOK을 저장하세요',
    createProjectButtonText: '새 프로젝트',
    projectNamePlaceholder: '프로젝트 이름을 입력하세요',
    projectEnterText1: '프로젝트 입장',
    projectEnterText2: '작업 공간 입장',
    createProjectTip: '먼저 프로젝트를 생성해 주세요'
  },
  image: {
    text2ImageTitle: '텍스트-이미지 변환',
    originalityTitle: '스케치-이미지 변환',
    styleExtensionTitle: '스타일 확장',
    styleFuseTitle: '스타일 블렌딩',
    tuneTitle: '영역 조정',
    recolorTitle: '스마트 색상 변경',
    backgroundTitle: 'AI 배경 변경',
    eraserTitle: '매직 지우개',
    cutoutTitle: '원클릭 컷아웃',
    flowerPatternExpansionTitle: '무결 타일',
    aiExpansionTitle: 'AI 확장',
    hdTitle: '업스케일',
    drawingTitle: 'Real-Time Design',
    patternTitle: '패턴 매핑',
    imageCount: '',
    generateButtonText: 'LOOK 생성',
    generateButtonSubscribeBoxTitle1: '첫 구독자 50% 할인',
    generateButtonSubscribeBoxTitle2: '프로 플랜 잠금 해제',
    generateButtonSubscribeBoxDesc1:
      '무료 체험이 만료되었나요? 지금 할인된 가격으로 더 많은 생성 권한을 잠금 해제하세요!',
    generateButtonSubscribeBoxDesc2: '프로로 업그레이드하여 실시간 디자인의 자유를 누리세요!',
    generateButtonSubscribeBoxButtonText1: '무료 체험 받기',
    generateButtonSubscribeBoxButtonText2: '프로 플랜으로 업그레이드',
    originalSizeText: '비율',
    uploadImageButtonText: '이미지 업로드',
    uploadPatternButtonText: '패턴 업로드',
    editMaskButtonText: '마스크 편집',
    removeMaskButtonText: '마스크 삭제',
    imageUploaderDesc:
      '<span style="color: #4c4c4c; font-size: 14px">클릭하거나 드래그하여 업로드</span><br/> <span style="color: #b0b2ae; font-size: 12px">(아래와 오른쪽의 저장 영역에서 이미지를 직접 드래그할 수 있습니다)</span>',
    generatePreviewText: '미리보기({count}/{max})',
    previewListHelpMessage1:
      '생성된 이미지는 이 목록에 임시로 저장되며, 최대 {max}개까지 저장됩니다. {max}개를 초과하면 가장 먼저 생성된 이미지가 삭제됩니다.',
    previewListHelpMessage2: '임시 이미지는 영구 저장과 추가 작업을 위해 앨범에 저장해야 합니다.',
    clearPreviewButtonText: '모든 미리보기 지우기',
    segmentErrorMessage: '이미지 의미 분석 실패, 다시 시도해 주세요',
    generatingMessage: '이미지 생성 중',
    previewWaitingMessage: '이미지 처리 중, 잠시만 기다려 주세요',
    previewFailedMessage: '이미지 처리 실패, 볼 수 없음',
    imageInQueueMessage: '대기열',
    imageNotVerifyMessage: '위반',
    saveImageButtonText: '앨범에 저장',
    deleteTmpImageButtonText: '임시 이미지 삭제',
    previewImageInfoText: '이미지 정보',
    promptDefaultPlaceholder: '디자인 설명이나 프롬프트 단어를 입력하여 생성 정확도를 높이세요',
    promptDefaultPlaceholder2: '꽃형 설명을 입력하세요',
    promptDefaultPlaceholder3: '이미지 설명을 입력하세요',
    promptDefaultPlaceholder4: '모델 설명을 입력하세요',
    removeBgErrorMessage: '배경 제거 실패',
    removeBgButtonText: '배경 제거',
    removeBgLoadingMessage: '배경 제거 중, 잠시만 기다려 주세요',
    cropTip1: '모델의 머리와 다리를 생성할 수 있도록 이미지 상하에 충분한 공간을 남겨두세요',
    cropTip2: '업로드된 이미지가 너무 작은 경우 적절한 크기로 자르세요',
    diyModelText: '사용자 정의 모델',
    commonModelText: '공용 모델',
    exclusiveModelText: '독점 모델',
    promptTitle: '프롬프트',
    promptTitle2: '꽃형 설명',
    promptTitle3: '이미지 설명',
    promptTitle4: '모델 설명',
    promptInputTitle: '디자인 특징 (다중 선택)\n',
    selectModelTitle: '모델 선택',
    referenceStrengthLabel: '참조 강도',
    modelSettingTitle: '모델 설정',
    advancedSettingsTitle: '고급 설정',
    negativePromptTitle: '네거티브 프롬프트',
    negativePromptPlaceholder: '이미지에 원하지 않는 요소를 입력하거나 선택하세요',
    generateCountTitle: '배치 크기',
    cleanerTitle: '전경 제거',
    maskSwitchViewButtonText: '보기 전환',
    regenerateButtonText: '재생성',
    imageLoadingMessage: '이미지 로딩 중',
    maskGenerateFailedMessage: '마스크 생성 실패',
    maskPreviewDialogConfirmButtonText1: '컷아웃 확인',
    maskPreviewDialogConfirmButtonText2: '마스크 생성',
    maskPreviewDialogCancelButtonText: '계속 편집',
    objectRemovalDialogCancelButtonText: '계속 편집',
    objectRemovalFailedMessage: '전경 제거 실패',
    magicMaskGenerateFailedMessage: '스마트 마스크 생성 실패',
    partMaskDialogTitle: '영역 선택',
    imageAnalyzingMessage: '이미지 분석 중',
    cutout: '컷아웃',
    maskDialogConfirmButtonText1: '미리보기 준비 중',
    maskDialogConfirmButtonText2: '미리보기 생성',
    maskDialogConfirmTip: '막혔나요? 다시 시도해 보세요!',
    rangeOfChangeLabel: '조정 수준',
    lesser: '낮음',
    more: '높음',
    disableModelDesc: '모델 비활성화, 스케치에 모델이 없는지 확인하세요',
    generateFailedMessage: '이미지 생성 작업 생성 실패',
    taskNotEnoughTip: '동시 생성 작업의 최대 수에 도달했습니다. 나중에 다시 시도해 주세요.',
    saveTip1:
      '{saveType} 저장은 이미지를 저장한 후 자동으로 선명도 향상 작업이 수행됨을 의미합니다.',
    saveTip2:
      '진행 중인 LOOK과 {saveType} 작업의 총 수가 동시 작업의 최대 수에 도달한 경우, {saveType} 저장 작업은 일시적으로 사용할 수 없습니다.',
    promptButtonText1: 'AI 향상',
    promptButtonText2: '이미지 설명',
    promptButtonMessage: '먼저 프롬프트를 입력하세요',
    promptButtonFailMessage: '생성 실패, 다시 시도해 주세요',
    colorMatchTitle: '색상 매칭',
    colorMatchSubject: '패션 일러스트레이션을 사진으로',
    colorMatchDesc: '원단의 원래 색상과 텍스처 표현',
    patternExpansionSize: '확장 크기',
    patternExpansionSizeSmall: '작음',
    patternExpansionSizeMedium: '중간',
    patternExpansionSizeLarge: '큼',
    flowerPatternExpansionStep1: '1.비방향성 패턴 업로드',
    flowerPatternExpansionStep2: '2.확장할 영역 선택',
    flowerPatternExpansionStep3:
      '3.LOOK는 패턴의 가장자리를 확장하여 원래의 패턴을 연속적인 패턴으로 변환합니다. 저장 또는 다운로드하여 후속 디자인에 사용할 수 있습니다.',
    maskCreateText: '마스크 만들기'
  },
  cleaner: {
    maskDialogTitle: '지울 영역 선택',
    maskDesc: '지울 영역 선택'
  },
  drawing: {
    generatingMessage: '생성 중, 잠시만 기다려 주세요',
    startDrawingMessage: '그리기를 시작해 주세요',
    waitingScreenMessage: '화면 미러링 대기 중...',
    canvasCropperGuideMessage: 'LOOK의 캔버스 크기에 맞게 화면을 잘라주세요',
    startDrawingButtonText: '디자인 시작',
    stopDrawingButtonText: '클릭하여 중지',
    videoNotSupportMessage: '현재 브라우저는 비디오 재생을 지원하지 않습니다',
    canvasGuideMessage1:
      '<img src="{image}" width="26" height="26" /> Procreate를 실행하고 <span style="font-weight: 700; text-decoration: underline">캔버스 브로드캐스팅</span>을 껐다가 켜주세요',
    canvasGuideMessage2: '캔버스 브로드캐스팅은 제대로 작동하기 위해 껐다가 다시 켜야 합니다',
    castScreenGuideMessage1: '현재 버전은',
    castScreenGuideMessage2: ' Procreate 화면 미러링만 지원합니다',
    castScreenGuideMessage2After: '',
    castScreenGuideMessage3: '가이드에 따라 iPad 화면 미러링 연결을 열어주세요 {placeholder}',
    castScreenGuideMessage4: '(두 기기가 같은 네트워크에 있어야 합니다)',
    screenPreviewTitle: '화면 캐스팅 미리보기',
    reCropButtonText: '다시 자르기'
  },
  hd: {
    scaleTitle: '이미지 품질 향상',
    imageClaritySD: '저장',
    imageClarityHD: 'HD로 저장',
    imageClarityUHD: 'UHD로 저장',
    imageClarityTextSD: 'SD',
    imageClarityTextHD: 'HD',
    imageClarityTextUHD: 'UHD',
    generatingMessage: ' 업스케일링'
  },
  matte: {
    maskDialogTitle: '유지할 영역 선택',
    maskDesc: '유지할 영역 선택',
    magicLabel: '스마트 컷아웃'
  },
  originality: {
    lineDrawingTitle: '스케치',
    lineDrawingUploadTitle: '스케치 업로드',
    sampleClothesTitle: '샘플 의류'
  },
  recolor: {
    maskDialogTitle: '색상을 변경할 영역 선택',
    maskDesc: '색상을 변경할 영역을 선택해 주세요',
    colorSelectTitle: '색상 선택',
    getColorWarningMessage: '현재 브라우저는 색상 선택기 기능을 지원하지 않습니다'
  },
  styleFusion: {
    referenceImageDialogTitle1: '스타일 이미지'
  },
  background: {
    maskDialogTitle: '유지할 영역 선택',
    maskDesc: '유지할 영역 선택',
    backgroundDialogTitle: '배경 추가',
    backgroundDescTitle: '배경 설명',
    promptInputPlaceholder: '배경 설명을 입력하여 생성 정확도를 높이세요',
    referenceBackgroundTitle: '참조 배경',
    intelligentFillLightLabel: '지능형 조명',
    backgroundGenerateTimeoutMessage: '배경 생성 시간 초과, 다시 시도해 주세요',
    backgroundGenerateFailedMessage: '배경 생성 실패, 다시 시도해 주세요',
    addBackgroundTitle: '배경 추가',
    backgroundSizeTitle: '배경 크기',
    effectPreviewMessage: '효과 미리보기',
    canvasEmptyMessage: '먼저 배경을 추가해 주세요'
  },
  text2Image: {
    textExampleMessage1:
      '이탈리아 모델이 오버사이즈 니트웨어를 입은 룩북 사진의 클로즈업 샷. 패션 브랜드의 아웃도어와 스트리트웨어를 대표하는 다양한 색상의 실로 만든 체크무늬 니트 스웨터. Campbell Addy 스타일로 촬영된 하이패션 에디토리얼 샷.',
    textExampleMessage2:
      '현대적인 중국 스타일의 긴 드레스를 입은 패셔너블한 중국 모델. 낮은 채도의 색상과 매칭되는 프린트가 특징. 상하이 패션위크의 런웨이 룩으로, 현대적인 패션 감각을 보여줍니다.',
    textExampleMessage3:
      '구조적인 분할, 현대적인 의상, 단순하고 깔끔하며 흐르는 듯한 디자인이 특징인 패션 모델의 클로즈업. 실크와 린넨 소재를 혼합한 의상으로, 패션 매거진 커버 사진에 완벽합니다.',
    textExampleMessage4:
      '패셔너블한 모델이 정교한 자수가 있는 흰색 셔츠를 입고 있습니다. 셔츠에는 큰 다크 레드 꽃무늬 패턴과 골드 자수 디테일이 있어 빈티지한 우아함을 더합니다. 모델은 골드 라운드 귀걸이를 착용하고 있으며, 깔끔하게 뒤로 넘긴 헤어스타일로 얼굴을 드러냅니다. 짙은 녹색 배경은 모델의 피부톤과 의상을 돋보이게 하며, 전체적인 이미지에 강한 예술성을 부여합니다. 사진은 부드러운 저채도 톤으로, 고요하고 시적인 분위기를 자아냅니다.',
    textExampleMessage5:
      '패셔너블한 모델이 혼자서 밝은 오렌지색 루즈 스웨터를 입고 있습니다. 두꺼운 니트 소재로 만들어진 스웨터는 하이넥 디자인과 약간 느슨한 소매가 특징입니다. 하의는 광택이 있고 단단한 텍스처의 다크 블루 A라인 가죽 스커트입니다. 모델은 투박한 플랫폼 하이힐을 신어 무게감을 더했습니다. 오렌지 프레임에 블루 렌즈가 있는 선글라스로 마무리하여 전체적인 스타일링에 미래적이고 드라마틱한 느낌을 줍니다. 의상은 고채도 색상과 강한 대비가 특징이며, 눈에 띄는 대담한 시각적 효과를 만듭니다. 액세서리와 메이크업은 독특하고 과장되어 개성과 예술성을 강조합니다. 배경은 단순합니다.',
    textExampleMessage6:
      '젊은 패셔너블한 여성이 노란색 형광 재킷을 입고 일본의 거리에 서 있습니다. 파란 하늘, 자연광, 상반신 샷.',
    textExampleMessage7:
      '우아한 백인 여성 모델이 다크 그레이 미니멀리스트 V넥 롱 코트와 마틴 부츠를 신고 있으며, Theo Angelopoulos 스타일로 촬영되었습니다. 코트는 Lemaire 브랜드의 캐시미어 원단으로 만들어졌으며, 주름과 겹쳐진 앞여밈이 특징이며 고요하고 성스러운 분위기를 자아냅니다. 장면은 안개 낀 숲에서 연출되었습니다.',
    textExampleMessage8:
      '보라색 배경 앞에서 대담한 초록색 니트 스웨터를 입은 패셔너블한 여성. 스웨터는 추상적인 얼굴을 연상시키는 흰색과 파란색 요소가 있는 독특한 디자인이 특징입니다. 원단은 두꺼운 니트로 보이며, 이런 종류의 의류에서 보온성과 텍스처를 위해 일반적으로 사용되는 울이나 울 혼방일 것 같습니다. 핏은 느슨하고 소매가 손목을 넘어가며, 캐주얼하고 오버사이즈입니다. 선명한 초록색이 전체적인 룩을 지배하며, 검은색 바지와 대비되어 눈에 띄는 색상 조합을 만듭니다. 전체적인 스타일은 아방가르드하며 현대 스트리트 패션에 속합니다.',
    textExampleMessage9:
      '한국의 패션 인플루언서가 넓은 소매가 있는 느슨한 라이트 블루 데님 셔츠를 입고 있습니다. 셔츠는 여러 군데 찢어지고 바랜 부분이 있어 빈티지 스타일을 나타냅니다. 모델은 또한 데님으로 만든 것으로 보이는 밝은 색상의 반바지를 입어 셔츠와 매치했습니다. 그녀는 직선의 긴 검은 머리에 중립적인 표정으로 정면을 바라보고 있습니다. 배경은 밝은 회색으로, 의상을 돋보이게 합니다. 필름 텍스처.',
    textExampleMessage10:
      '한국 모델이 미니멀한 배경 앞에 서 있습니다. 그녀는 후드가 달린 오버사이즈 라이트 올리브 그린 니트 카디건을 입고 있으며, 매우 편안하고 캐주얼해 보입니다. 카디건은 두꺼운 니트 원단으로 만들어졌으며 입체적인 기하학적 패턴이 특징입니다. 핏은 느슨하며 가을이나 겨울에 입기 적합합니다. 모델은 또한 다크 브라운 야구 모자를 쓰고 있으며, 모자의 로고가 선명하게 보입니다. 그녀의 표정은 중립적이며, 시선은 한쪽을 향하고 있어 편안하고 여유로운 분위기를 자아냅니다. 전체적인 스타일은 캐주얼하고 패셔너블하며, 편안함과 현대성을 강조합니다. 사진은 필름과 같은 텍스처를 가지고 있습니다.',
    textExampleMessage11:
      '모델이 중립적인 배경 앞에 서 있습니다. 그녀는 넓은 소매와 비대칭 밑단 디자인이 특징인 독특한 오프화이트 의상을 입고 있으며, 전통적인 중국 의상을 연상시키는 스타일로 여러 겹의 원단이 겹쳐져 있습니다. 원단은 부드럽고 유동적이며 약간의 텍스처가 있어, 가벼운 면이나 실크 혼방으로 만들어진 것 같습니다. 핏은 느슨하여 편안하면서도 세련된 현대적인 룩을 제공합니다. 의상은 주로 오프화이트 색상이며, 검은색 바지가 대비를 이룹니다. 전체적인 스타일은 우아함이 가미된 미니멀리즘을 지향합니다. 모델은 단정한 외모에 단순한 헤어스타일과 차분한 표정으로 전체적인 룩에 품위와 자신감을 더합니다.',
    generationRatioTitle: '이미지 비율',
    tryText: '시도해 보기',
    freeProportionText: '자유'
  },
  tune: {
    maskDialogTitle: '수정할 영역 선택',
    maskDesc: '인페인트 영역 선택',
    promptTitle: '프롬프트'
  },
  pattern: {
    maskDialogTitle: '수정할 영역 선택',
    maskDesc: '인페인트 영역 선택',
    assistImagesTitle: '패턴'
  },
  modelTryOn: {
    modelImageDialogTitle1: '모델 업로드',
    modelImageDialogTitle2: '의상 업로드',
    maskDesc: '의상 변경 영역 선택',
    maskDialogTitle: '의상 변경 영역 선택',
    upperBodyTitle: '상의/드레스',
    dressTitle: '하의',
    loadingText: '스마트 선택 중, 잠시만 기다려주세요...',
    errorText: '스마트 선택 실패, 다시 시도해 주세요',
    upperBodyMaskDialogTitle: '상의/드레스 영역 선택',
    dressMaskDialogTitle: '하의 영역 선택',
    singleMaskDialogTitle: '모델 영역 선택',
    single: '단일 옷',
    multi: '다중 옷',
    singleTitle: '모델'
  },
  modelFace: {
    uploadImageTitle: '원본 이미지 업로드',
    maskDialogTitle: '사람의 얼굴 영역을 그리세요',
    maskDesc: '사람의 얼굴 영역을 그리세요',
    selectModelTitle: '모델 업로드',
    modelSelectorDesc: '<span style="color: #4c4c4c; font-size: 14px">모델을 선택</span>',
    headSize: '머리 크기'
  },
  diyModel: {
    sex: '성별',
    male: '남성',
    female: '여성',
    age: '나이',
    kid: '5',
    juvenile: '15',
    adult: '25',
    youth: '35',
    middleAged: '50',
    elderly: '60',
    color: '피부톤',
    bodyShape: '체형',
    hair: '머리',
    length: '길이',
    hairstyle: '헤어스타일',
    slenderBody: '슬림',
    hourglassBody: '평균',
    muscularBody: '근육질',
    babyFatBody: '통통',
    shortAndFatBody: '작고 통통',
    curvaceousBody: '곡선미',
    straight: '직모',
    wavy: '웨이브',
    curly: '곱슬',
    braided: '땋은 머리',
    naturallyCurly: '자연 곱슬',
    updo: '업스타일',
    airBangs: '시스루 뱅',
    dreadlocks: '드레드락',
    ponytail: '포니테일',
    bald: '대머리',
    centerPartedHair: '가운데 가르마',
    bangs: '풀 뱅',
    frontBangs: '앞머리',
    short: '짧은',
    long: '긴',
    shoulderLength: '어깨 길이',
    extraLongHair: '매우 긴',
    pixieCut: '귀 길이',
    collarboneLengthHair: '쇄골 길이',
    shoulderLengthHair: '허리 길이',
    waistLengthHair: '스타일',
    fairSkinWhite: '밝은 피부톤',
    darkSkin: '어두운 피부톤',
    yellowSkin: '황색 피부톤',
    asian: '아시아인',
    european: '유럽인',
    african: '아프리카인',
    american: '미국인',
    middleEastern: '중동인'
  },
  maskDialogHelpTip: {
    mask: '마우스로 클릭하여 유지할 영역을 선택하세요',
    matte:
      '이미지를 업로드하고 마우스로 클릭하여 유지할 영역을 선택하세요. 컷아웃이 필요하지 않은 경우 확인 버튼을 직접 클릭하세요.',
    cutout: '마우스로 클릭하여 유지할 영역을 선택하세요',
    part: '마우스로 클릭하여 마스크로 사용할 영역을 선택하세요',
    objectRemoval:
      '전경의 일부를 제거하려면 "전경 제거"를 클릭한 다음 마우스로 제거할 영역을 클릭하세요. 필요하지 않은 경우 "확인" 버튼을 직접 클릭하세요.'
  },
  subscribe: {
    subscribeTitle:
      '첫 구독 특별&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">{discount}% 할인</span>&nbsp;혜택',
    subscribeTitleFree:
      '&nbsp;<span style="font-size: 32px; font-weight: 500; line-height: 44.8px">7일 무료 멤버십</span> 제공',
    person: '명',
    month: '월',
    year: '년',
    currency: '$',
    mostPopularText: '가장 인기',
    noMemberText: '멤버십 없음',
    subscribeSubText:
      '멤버십 만료 후 자동 갱신되며, <span style="color: #0d0d0d">다음 달부터 정상가로 전환</span>, 언제든지 취소 가능',
    subscribeSubTextFree: '구독은 언제든지 추가 비용 없이 취소할 수 있습니다',
    priceNegotiableText: '영업팀 문의',
    tryThisText: '가장 인기',
    payButtonText1: '구독하기',
    payButtonText1Free: '$0.00 7일 무료 멤버십 받기!',
    payButtonText2: '구독하기',
    payButtonText3: '플랜 업그레이드',
    payButtonText4: '현재 플랜',
    payButtonText5: '고객 서비스',
    payButtonText6: '결제 정보 수정',
    payButtonText7: '구독',
    payMessage1: '은(는) 무료 체험 종료 후의 플랜입니다',
    payMessage2: '활성화 중',
    payMessage3: '15일 체험 종료 후 결제',
    payMessage4: '결제',
    payMessage5: 'QR 코드를 스캔하여 결제를 완료하세요',
    payMessage6: '만료 시 {currency}{amount}/월로 자동 갱신, 언제든지 취소 가능',
    payMessage7: '체험 만료 시 {currency}{amount}/월로 자동 갱신, 언제든지 취소 가능',
    payMessage8: 'QR 코드를 스캔하여 서명 과정을 완료하세요',
    paySuccessText: '구독 성공',
    paySubText: '활성화는 동의를 의미합니다',
    freeMemberSuccessDesc:
      '15일 멤버십 체험 종료 후 요금이 청구됩니다. 구독은 추가 비용 없이 언제든지 취소할 수 있습니다.',
    receiveAwardTitle: '🎉LOOK에 오신 것을 환영합니다',
    receiveAwardTitleTaskGuide: '🎉1일 무료 체험이 적용되었습니다!',
    receiveAwardSubject:
      '<br><span style="font-size: 24px; font-weight: 700">{number}일&nbsp;무료 체험</span>&nbsp;을 준비했습니다',
    receiveAwardSubjectTaskGuide:
      'LOOK의 핵심 기능을 쉽게 체험하세요',
    receiveAwardTip: '더 원하시나요?',
    receiveAwardButtonTextTaskGuide: '체험 시작',
    receiveAwardButtonText: '{number}일 무료 체험 {currency}0.00',
    memberInvitedOnly: '초대 전용',
    memberTipsStarter: '개인 디자이너와 AI 초보자에게 완벽한 플랜입니다.',
    memberTipsPlus: '고급 AI 도구가 필요한 경험 있는 디자이너를 위한 플랜입니다.',
    memberTipsPro: '완전한 AI 파워와 프리미엄 기능을 찾는 전문가를 위한 플랜입니다.',
    memberFreeDesc1Label: '생성 이미지 수',
    memberFreeDesc1Value: '8장/일',
    memberFreeDesc2Label: '해상도',
    memberFreeDesc2Value: '표준',
    memberFreeDesc3Label: '동시 작업 수',
    memberFreeDesc3Value: '2',
    memberFreeDesc4Label: 'Real-Time Design',
    memberFreeDesc4Value: '없음',
    memberDescStarter0Label: '생성',
    memberDescStarter0Value: '무제한',
    memberDescStarter1Label: '생성 속도',
    memberDescStarter1Value: '일반',
    memberDescStarter2Label: '동시 생성',
    memberDescStarter2Value: '{count}',
    memberDescStarter3Label: '생성 빈도',
    memberDescStarter3Value: '50 / 4시간',
    memberDescStarter4Label: '업스케일 빈도',
    memberDescStarter4Value: '8 / 4시간',
    memberDescStarter5Label: '업스케일 이미지 품질',
    memberDescStarter5Value: '2K',
    memberDescStarter6Label: 'Real-Time Design',
    memberDescStarter6Value: '1200분 / 월',
    memberDescPlus0Label: '생성',
    memberDescPlus0Value: '무제한',
    memberDescPlus1Label: '생성 속도',
    memberDescPlus1Value: '빠름',
    memberDescPlus2Label: '동시 생성',
    memberDescPlus2Value: '{count}',
    memberDescPlus3Label: '생성 빈도',
    memberDescPlus3Value: '150 / 4시간',
    memberDescPlus4Label: '업스케일 빈도',
    memberDescPlus4Value: '16 / 4시간',
    memberDescPlus5Label: '업스케일 이미지 품질',
    memberDescPlus5Value: '3K',
    memberDescPlus6Label: 'Real-Time Design',
    memberDescPlus6Value: '3600분 / 월',
    memberDescPro0Label: '생성',
    memberDescPro0Value: '무제한',
    memberDescPro1Label: '생성 속도',
    memberDescPro1Value: '터보',
    memberDescPro2Label: '동시 생성',
    memberDescPro2Value: '{count}',
    memberDescPro3Label: '생성 빈도',
    memberDescPro3Value: '무제한',
    memberDescPro4Label: '업스케일 빈도',
    memberDescPro4Value: '48 / 4시간',
    memberDescPro5Label: '업스케일 이미지 품질',
    memberDescPro5Value: '4K',
    memberDescPro6Label: 'Real-Time Design',
    memberDescPro6Value: '무제한',
    stripeConfirmMessage1: '주문 처리 중',
    stripeConfirmMessage2: '구독이 성공적으로 완료되었는지 확인해 주세요?',
    stripeConfirmMessage3: '카드의 유효성을 확인하기 위해 {currency}1의 사전 승인이 이루어집니다.',
    stripeConfirmMessage4:
      '이는 확인용으로만 사용되며 <span style="font-weight: 600; color: #0d0d0d">실제 요금이 청구되지 않으니</span> 안심하세요.',
    stripeSuccessMessage: '주문 완료!',
    stripeFailedMessage: '확인 실패, 다시 시도하거나 다른 결제 수단을 사용해 주세요.',
    stripeConfirmButtonText: '구독 완료',
    stripeCancelButtonText: '취소',
    stripeEditBillingMessage: '결제 구독 수정 중...',
    stripeEditBillingConfirmButtonText: '완료',
    stripeUpgradeMessage: '구독을 업그레이드하시겠습니까?',
    stripeUpgradeSuccessMessage: '업그레이드 성공!',
    stripeSubscribeRenewButtonText: '구독 재개',
    stripeSubscribeRenewConfirmMessage: '갱신을 재개하시겠습니까?',
    stripeSubscribeRenewSuccessMessage: '구독 재개됨',
    stripeSubscribeCancelButtonText: '해지',
    stripeSubscribeCancelConfirmMessage: '갱신을 취소하시겠습니까?',
    stripeSubscribeCancelSuccessMessage: '구독 취소됨',
    cancelQuestionaireTitle: '구독 취소 이유를 선택해 주세요 (단일 선택).',
    cancelQuestionaireSubject:
      '다음 옵션 중 하나를 선택하여 (단일 선택) 구독 취소 이유를 알려주세요.',
    cancelQuestionaireSelection1: '그냥 구독을 취소하고 싶습니다',
    cancelQuestionaireSelection2: '가격이 너무 비쌉니다',
    cancelQuestionaireSelection3: '서비스 내용이 더 이상 제 요구를 충족하지 않습니다',
    cancelQuestionaireSelection4: '사용자 경험이 좋지 않습니다',
    cancelQuestionaireSelection5: '기술적 문제 (예: 잦은 오류나 중단)',
    cancelQuestionaireSelection6: '더 나은 대안을 찾았습니다',
    cancelQuestionaireSelection7: '기타 (구체적으로 명시해 주세요)',
    cancelQuestionaireSelection8: '더 나은 것들',
    cancelQuestionaireSubmiteButtonText: '제출',
    cancelQuestionaireCancelButtonText: '조금 더 사용해 보겠습니다',
    cancelSuccessMainTitle: '구독이 취소되었습니다',
    cancelSuccessSubject: '곧 이메일로 확인 메시지를 받으실 것입니다.',
    reactivateTitle: '실수로 취소하셨나요?',
    reactivateSubject: '걱정하지 마세요, 다시 활성화해 드리겠습니다!',
    reactivateButtonText: '지금 재활성화',
    upgradeTitle: '플랜 업그레이드',
    upgradeSubject: '구독 업그레이드는 즉시 적용됩니다.',
    upgradeDesc: '비용은 현재 달의 남은 일수에 따라 비례 배분되어 새 플랜의 요금에서 차감됩니다.',
    qrcodeTimeout: 'QR 코드 만료',
    clickToRefresh: '다시 시도하려면 클릭',
    cycleText: '월간 청구',
    yearlyText: '연간 청구',
    paymentTypeMonthlyText: '월간 청구',
    paymentTypeYearlyText: '연간 청구',
    freeUsageText: '오늘 남은 무료 사용 횟수: {count}',
    currentSubscription: '현재 구독',
    expiredText: '갱신일: {date}'
  },
  similer: {
    similerTitle: '이미지 검색',
    similerWaitingMessage: '컴포넌트 초기화 중, 잠시만 기다려 주세요',
    similerSearchFailedMessage: '검색 실패, 다시 시도하려면 클릭',
    similerNoSimilarMessage: '유사한 이미지를 찾을 수 없습니다',
    similerLoadingMoreDetailImageError:
      '고해상도 이미지가 로드되지 않았습니다, 다시 시도하려면 클릭'
  },
  taskType: {
    generate: '이미지 생성',
    upscale: '업스케일',
    realtimeDesign: 'Real-Time Design'
  },
  contextMenu: {
    copy: '복사',
    paste: '붙여넣기',
    selectAll: '모두 선택'
  },
  rewardTask: {
    rewardTaskListTitle1: '친구 초대 시 8일 무료 체험 제공',
    rewardTaskListTitle1Intl: '핵심 기능 테스트',
    rewardTaskListDesc1: '전화번호 연결',
    rewardTaskListGuide1: '전화번호 연결',
    rewardTaskListDesc2: '프로젝트 생성',
    rewardTaskListGuide2: '프로젝트 생성',
    rewardTaskListDesc3: '스케치-이미지',
    rewardTaskListGuide3:
      '스케치, 스타일 드로잉, 패션 일러스트레이션 및 실제 사진을 현실적인 효과로 변환하려면 이미지를 클릭하거나 드래그하여 업로드하세요.',
    rewardTaskListDesc4: '스케치-이미지 (색상 매칭)',
    rewardTaskListGuide4:
      '스케치-이미지 변환 에서 <span style="color: #4c4c4c; font-weight: 600; text-decoration-line: underline">색상 복원</span>을 활성화하면 원본 색상이 사용됩니다. 비활성화 시 랜덤 색상이 생성됩니다.',
    rewardTaskListDesc5: '스타일 확장',
    rewardTaskListGuide5:
      '스타일 확장에서 AI는 업로드한 의류 이미지를 기반으로 다양한 변형을 빠르게 생성할 수 있습니다.',
    rewardTaskListDesc6: '스타일 블렌딩',
    rewardTaskListGuide6:
      '스타일 블렌딩은 의류와 영감이 되는 소재를 병합하여 서로 다른 패션 스타일을 융합하기 위해 두 개의 이미지를 업로드해야 합니다.',
    rewardTaskListDesc7: '텍스트-이미지',
    rewardTaskListGuide7:
      'LOOK을 생성하려면 디자인에 대한 설명을 입력하세요. <img src="{img}" style="vertical-align: middle; width: 13px; height: 13px;" /> AI 개선 및 이미지 설명을 사용하여 설명 작성에 도움을 받을 수 있습니다.',
    sketchToImageInitPrompt:
      '아름다운 모델이 큰 주름과 물결이 있는 루즈한 스커트가 달린 비대칭 오프숄더 가운을 입고 있습니다. 어두운 색상의 뾰족한 하이힐과 매치되어 있으며, 이 드레스는 약간의 메탈릭한 광택 소재로 우아함과 현대성을 자아냅니다.',
    sketchToImageColorInitPrompt:
      '실버 그레이 린넨 롱스커트, 검정 터틀넥 스웨터, 따뜻한 노란색 체크 베스트로 구성된 우아한 의상을 입은 모델의 패션 사진. 두꺼운 굽의 부츠와 큰 리본이 달린 따뜻한 노란색과 검정색 체크무늬 벨트가 포함되어 있습니다. 베스트와 스커트에는 기하학적 패턴이 장식되어 있습니다. 그녀의 머리는 이마 위로 높게 빗어 올려져 있고 선글라스를 착용하고 있습니다. 전신 샷.',
    styleExtensionInitPrompt:
      '흰색 배경에 날카로운 라펠과 비대칭 포켓 디테일이 특징인 구조적인 크롭 블레이저를 특징으로 하는 하이패션 의상. 블레이저는 레이어드 패널과 흐르는듯한 비대칭 밑단이 돋보이는 드레이프 하이웨이스트 스커트와 매치되어 있습니다. 디자인은 맞춤형 정교함과 유동적인 드레이핑이 조화를 이룬 아방가르드한 실루엣을 강조합니다. 소재는 면이나 면혼방과 같은 가벼운 무광 원단으로, 부드러우면서도 구조적인 외관을 선사합니다. 차분한 어스 그린 컬러는 미니멀하고 현대적인 미학을 한층 돋보이게 합니다. 전체적인 디자인은 현대적인 테일러링과 예술적 유동성의 균형을 반영하여 런웨이나 에디토리얼 패션에 완벽합니다. 제품 사진, 디테일한 텍스처.',
    styleFusionInitPrompt:
      '가슴에 입체적인 리본 패턴이 니트로 짜여진 두꺼운 컬러풀한 스웨터, 흰색 배경.',
    text2ImageInitPrompt:
      '오버사이즈 블레이저와 가죽 스커트를 입고, 뒤꿈치에 거대한 리본이 달린 부츠를 신은 긴 다리의 흑인 모델이 흰색 배경에서 보그 패션 사진을 위해 포즈를 취하고 있습니다. 이미지는 초현실적으로 사실적입니다.',
    getRewardButtonText1: '완료',
    limitTime: '제한 시간',
    guideStartButtonText: '생성',
    confirmCloseDialogTitle: '튜토리얼 건너뛰기',
    confirmCloseDialogDesc: '튜토리얼을 건너뛰시겠습니까? 나중에 다시 볼 수 없습니다.',
    confirmCloseDialogCancelButtonText: '취소',
    confirmCloseDialogConfirmButtonText: '예, 건너뛰기',
    rewardTitle: '디자인 향상이 기다리고 있습니다!',
    rewardDescription: '쿠폰을 사용하여 새로운, 강력한 디자인 기능을 탐색하세요.',
    couponType1: '할인 쿠폰',
    couponType2: '멤버십',
    expiredText: '유효기간: ',
    useNow: '지금 사용하기'
  },
  login: {
    success: '안녕하세요, 디자이너님!',
    closeWindow: '로그인이 성공적으로 완료되었습니다. 이 창을 닫을 수 있습니다.'
  },
  update: {
    updateDialogTitle: '업데이트',
    updateDialogMessage: '새로운 버전이 있습니다. 업데이트 하시겠습니까?',
    updateDialogCurrentVersion: '현재 버전',
    updateDialogNewVersion: '새로운 버전',
    updateDialogCancelButtonText: '지금 하지 않기',
    updateDialogUpdateButtonText: '업데이트',
    updateDialogUpdateButtonLoadingText: '업데이트 중...'
  },
  updateError: {
    updateErrorDialogTitle: '업데이트',
    updateErrorDialogMessage: '새로운 버전이 있습니다. 업데이트 하시겠습니까?',
    updateErrorDialogButtonText: '업데이트'
  },
  updateProgress: {
    updateProgressDialogTitle: '업데이트 중...'
  },
  remainingBalance: {
    realTimeDesign: '리얼타임 디자인 시간',
    minute: '분',
    hour: '시간',
    frequency: '주기',
    upscale: '업스케일',
    image: '이미지',
    last: '남은',
    unlimited: '제한 없음'
  },
  compositor: {
    opacity: '불투명도',
    saturation: '채도',
    brightness: '밝기',
    contrast: '대비',
    hue: '색상',
    depthMapFailed: '깊이 맵 생성 실패, 다시 시도하세요'
  },
  coupon: {
    couponListTitle: '내 쿠폰',
    couponExpireCountdown: '남은 시간: ',
    couponExpire: '유효기간: ',
    couponListEmpty: '사용 가능한 쿠폰이 없습니다',
    couponListEmptyDescription1: 'LOOK의 공식 Discord 채널에 참여',
    couponListEmptyDescription2: '활동에 참여하여 훌륭한 선물을 받으세요!',
    couponListEmptyButton: 'Discord에 참여'
  },
  plugins: {
    pluginsTitle: '플러그인 마켓',
    addPluginButtonText: 'PIN',
    removePluginButtonText: 'UNPIN',
    addedPluginButtonText: 'PINNED',
    noImages: '플러그인 이미지 없음',
    noPluginComponentText:
      '플러그인 페이지를 찾을 수 없습니다. 플러그인이 올바르게 구성되어 있는지 확인해 주세요',
    editPluginsButtonText: '플러그인 편집',
    editPluginsCompletedButtonText: '편집 완료',
    morePluginsButtonText: '더 많은 플러그인',
    removePluginTipsTitle: '플러그인 삭제',
    removePluginTips1: '삭제된 플러그인은',
    removePluginTips2:
      '<span style="color: #0d0d0d; font-weight: 600;">플러그인 마켓</span> 에서 다시 추가할 수 있습니다',
    pluginDisabled: '플러그인 사용 불가능',
    pluginsTips: {
      title: 'LOOK AI',
      subtitle: '플러그인 마켓 사용 가능!',
      plugintipTitle1: '통합 도구:',
      plugintipDesc1:
        '새로운 플러그인 마켓을 만나보세요! 스마트 리컬러, AI 배경 변경, 매직 지우개, 원클릭 컷아웃 등 여러분이 좋아하는 모든 기능을 한 곳에 모았습니다. PIN만 하면 바로 사용할 수 있습니다!',
      plugintipTitle2: '작업 공간 맞춤 설정:',
      plugintipDesc2:
        '플러그인 마켓 > 플러그인 추가 > 왼쪽 도구 모음에서 "플러그인 편집"을 클릭한 후, 아이콘을 원하는 대로 드래그하여 정렬하세요! 여러분의 LOOK, 여러분의 규칙!',
      plugintipTitle3: '더 많은 플러그인 곧 출시!',
      plugintipDesc3:
        '아이디어가 있으신가요? 원하는 새로운 도구나 피드백을 알려주세요. LOOK는 여러분을 위해 만들어졌으며, 여러분의 의견을 기다립니다!'
    },
    pluginsTipsFooter: {
      discord: 'DISCORD 커뮤니티 참여',
      instagram: '인스타그램에서 더 많은 것을 보세요',
      email: '이메일 보내기: {email}'
    }
  }
}

export default ko as any
